<div fxLayout="column" fxLayoutGap="20px">
  <app-page-header title="Status da Documentação de Inscrição">
    <button mat-raised-button color="basic" (click)="downloadAnexo()"><mat-icon>download</mat-icon> Baixar Edital</button>
    <app-export-button (export)="verificaQtdRegistrosParaExportar()"></app-export-button>
  </app-page-header>
  <h1>{{ this.idConcurso + '-' + this.campus }}</h1>
  <h1>{{ this.tituloConcurso }}</h1>

  <!-- <mat-form-field appearance="outline" fxLayoutAlign="start start">
    <mat-label>Filtrar Pagamento</mat-label>
    <mat-select name="pago" [(value)]="filtroPago" (selectionChange)="getData()">
      <mat-option value="TODOS">Todos</mat-option>
      <mat-option value="PAGO">Pago</mat-option>
      <mat-option value="AGUARDANDO_PAGAMENTO">Aguardando Pagamento</mat-option>
    </mat-select>
  </mat-form-field> -->

  <app-search-input #searchInput></app-search-input>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="inscricao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
        <td mat-cell *matCellDef="let row">{{ row.idInscricao }}</td>
      </ng-container>

      <ng-container matColumnDef="candidato">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Candidato</th>
        <td mat-cell *matCellDef="let row">
          <p>{{ row.nomeSocial || row.nome }}</p>
          <p><b>CPF</b> {{ row.cpf }}</p>
          <p><b>RG</b> {{ row.rg }}</p>
        </td>
      </ng-container>

      <ng-container matColumnDef="contato">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Contato</th>
        <td mat-cell *matCellDef="let row">
          <p>{{ row.email }}</p>
          <p>{{ row.celular }}</p>
          <p>{{ row.telefone }}</p>
        </td>
      </ng-container>

      <ng-container matColumnDef="statusFase1">
        <th mat-header-cell *matHeaderCellDef>Documentos Pendentes 1ª Fase</th>
        <td mat-cell *matCellDef="let row">
          <p>
            <b>Situação:{{ row.situacaoFase1 }}</b>
          </p>
          <p>{{ row.totalObrigatorioPendente }} Obrigatórios</p>
          <p>{{ row.totalOpcionalNaoEnviado }} Opcionais</p>
        </td>
      </ng-container>

      <ng-container matColumnDef="statusFase2" *ngIf="mostrarColuna">
        <th mat-header-cell *matHeaderCellDef>Documentos Pendentes 2ª Fase</th>
        <td mat-cell *matCellDef="let row">
          <p>
            <b>Situação:{{ row.situacaoFase2 }} </b>
          </p>
          <p>{{ row.totalObrigatorioPendenteSegundaFase }} Obrigatórios</p>
          <p>{{ row.totalOpcionalNaoEnviadoFase2 }} Opcionais</p>
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="pago">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Pago</th>
        <td mat-cell *matCellDef="let row">
          <p>Pago: {{ row.pago ? 'Sim' : 'Aguardando Pagamento' }}</p>
          <p>Autor: {{ row.pagoUsuario }}</p>
          <p>Data: {{ row.pagoData | date : 'dd/MM/yyyy HH:mm:ss' }}</p>
          <p>Concluído: {{ row.pagoConcluida ? 'Sim' : 'Não' }}</p>
        </td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <ng-container *ngIf="mostraColunaSegundaFase(this.tipoConcurso); then colspanIgual; else alteraColspan">
      </ng-container>
      <ng-template #colspanIgual>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="6">
            <app-table-no-data [searchValue]="searchInput?.value"></app-table-no-data>
          </td>
        </tr>
      </ng-template>
      <ng-template #alteraColspan>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="5">
            <app-table-no-data [searchValue]="searchInput?.value"></app-table-no-data>
          </td>
        </tr>
      </ng-template>
    </table>
    <app-default-paginator #paginator [length]="totalElements"></app-default-paginator>
  </div>
</div>
